<template>
  <div>
    <mymenu />
    <div class="notice-wrap">
      <div class="notice-header">消息列表</div>
      <div v-loading="loading">
        <div v-if="resData.length" class="notice-list">
          <div class="notice-item" v-for="item in resData" :key="item.id" @click="check(item)">
            <div class="notice-item-top">
              <span class="notice-title">{{ item.title }}</span>
              <span class="notice-time">{{ item.create_time }}</span>
            </div>
            <div class="notice-summary" v-html="getSummary(item.content)"></div>
          </div>
        </div>
        <div v-if="!resData.length && !loading" class="empty-tip">暂无通知</div>
      </div>
      <bottommenu />
    </div>

    <el-dialog :title="activeItem.title" :visible.sync="dialogCheck" width="680px" top="8vh">
      <div class="notice-detail-content" v-html="decodeHtml(activeItem.content)"></div>
      <div class="notice-detail-time">{{ activeItem.create_time }}</div>
      <span slot="footer">
        <el-button size="small" @click="dialogCheck = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mailbox } from "@/api";
import { mapState } from "pinia";
import { useMainStore } from "@/store/piniaStore";
export default {
  data() {
    return { resData: [], loading: false, dialogCheck: false, activeItem: {} };
  },
  computed: {
    ...mapState(useMainStore, { projectDetail: "getProjectDetail" }),
  },
  methods: {
    decodeHtml(html) {
      if (!html) return "";
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    getSummary(content) {
      const decoded = this.decodeHtml(content);
      const text = decoded.replace(/<[^>]+>/g, "").replace(/\s+/g, " ").trim();
      return text.length > 80 ? text.substring(0, 80) + "..." : text;
    },
    check(item) {
      this.activeItem = item;
      this.dialogCheck = true;
    },
  },
  mounted() {
    this.loading = true;
    const projectId = this.projectDetail?.project_info?.id;
    mailbox(projectId ? { project_id: projectId } : {})
      .then((res) => {
        this.loading = false;
        if (res.data.code === 1) this.resData = (res.data.data || []).reverse();
      })
      .catch(() => { this.loading = false; });
  },
};
</script>

<style scoped>
.notice-wrap {
  width: 80%;
  margin: 30px auto 0;
  min-height: 400px;
}
.notice-header {
  font-size: 16px;
  font-weight: 500;
  padding: 12px 16px;
  background: #fafafa;
  color: #333;
  border-bottom: 1px solid #ebeef5;
}
.notice-list {
  background: #fff;
}
.notice-item {
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.2s;
}
.notice-item:hover {
  background: #f5f7fa;
}
.notice-item-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.notice-title {
  font-size: 15px;
  font-weight: 500;
  color: #303133;
}
.notice-time {
  font-size: 13px;
  color: #909399;
  flex-shrink: 0;
  margin-left: 16px;
}
.notice-summary {
  font-size: 13px;
  color: #909399;
  line-height: 1.6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.empty-tip {
  text-align: center;
  color: #999;
  padding: 60px 0;
  font-size: 14px;
}
.notice-detail-content {
  line-height: 1.8;
  font-size: 14px;
  color: #606266;
  word-break: break-word;
}
.notice-detail-content img {
  max-width: 100%;
}
.notice-detail-time {
  text-align: right;
  color: #909399;
  font-size: 13px;
  margin-top: 20px;
  padding-top: 12px;
  border-top: 1px solid #ebeef5;
}
</style>
